import { render, staticRenderFns } from "./addGroup.vue?vue&type=template&id=acf5111a&scoped=true&lang=html&"
import script from "./addGroup.vue?vue&type=script&lang=js&"
export * from "./addGroup.vue?vue&type=script&lang=js&"
import style0 from "./addGroup.vue?vue&type=style&index=0&id=acf5111a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf5111a",
  null
  
)

export default component.exports